import { render } from "./NewDocumentsCard.vue?vue&type=template&id=83f9292e&scoped=true"
import script from "./NewDocumentsCard.vue?vue&type=script&lang=js"
export * from "./NewDocumentsCard.vue?vue&type=script&lang=js"

import "./NewDocumentsCard.vue?vue&type=style&index=0&id=83f9292e&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83f9292e"]])

export default __exports__